import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const OvernightsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--overnights']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
